<template>
	<ActivityBadgeLayout :class="classes">
		<FontAwesomeIcon :icon="[ `fas`, `angle-double-up` ]" />
	</ActivityBadgeLayout>
</template>

<script>
import { Direction, ConfidenceLevel } from "@teaming/common-enums";
import ActivityBadgeLayout from "./ActivityBadgeLayout";

export default {
	name: "ConfidenceChangeActivityBadge",
	components: {
		ActivityBadgeLayout,
	},
	props: {
		confidenceLevel: {
			type: String,
			required: true,
			validator( value ) {
				return [
					ConfidenceLevel.HIGH,
					ConfidenceLevel.MEDIUM,
					ConfidenceLevel.LOW,
				].includes( value );
			},
		},
		direction: {
			type: String,
			required: true,
			validator( value ) {
				return [
					Direction.UP,
					Direction.DOWN,
				].includes( value );
			},
		},
	},
	computed: {
		classes() {
			const { confidenceLevel, direction, } = this;
			return {
				"confidence-change-activity-badge": true,
				"theme--DEFAULT": true,
				"theme--HIGH": confidenceLevel === ConfidenceLevel.HIGH,
				"theme--MEDIUM": confidenceLevel === ConfidenceLevel.MEDIUM,
				"theme--LOW": confidenceLevel === ConfidenceLevel.LOW,
				"direction--up": direction === Direction.UP,
				"direction--down": direction === Direction.DOWN,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
$badgeColor: $color1-500;
$badgeBackgroundColor: $color1-100;

$badgeColorHIGH: $color4-500;
$badgeBackgroundColorHIGH: $color4-100;

$badgeColorMEDIUM: $color5-500;
$badgeBackgroundColorMEDIUM: $color5-100;

$badgeColorLOW: $color7-500;
$badgeBackgroundColorLOW: $color7-100;

.theme--DEFAULT {
	background-color: $badgeBackgroundColor;

	* {
		color: $badgeColor;
	}
}

.theme--HIGH {
	background-color: $badgeBackgroundColorHIGH;
	* {
		color: $badgeColorHIGH;
	}
}

.theme--MEDIUM {
	background-color: $badgeBackgroundColorMEDIUM;
	* {
		color: $badgeColorMEDIUM;
	}
}

.theme--LOW {
	background-color: $badgeBackgroundColorLOW;
	* {
		color: $badgeColorLOW;
	}
}

.direction--up {
	-moz-transform: rotate(0deg);
	-webkit-transform: rotate(0deg);
	-o-transform: rotate(0deg);
	-ms-transform: rotate(0deg);
	transform: rotate(0deg);
}

.direction--down {
	-moz-transform: rotate(180deg);
	-webkit-transform: rotate(180deg);
	-o-transform: rotate(180deg);
	-ms-transform: rotate(180deg);
	transform: rotate(180deg);
}
</style>
